import React, { PureComponent } from 'react';
import Icon from '../icon';
import { stopEvent, stopPropagation } from '../_util/EventManager';
export default class CloseButton extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            stopEvent(e);
            const { onClose, value, index } = this.props;
            onClose(e, value, index);
        };
    }
    render() {
        return (React.createElement(Icon, { type: "cancel", onClick: this.handleClick, onFocus: stopPropagation, onMouseDown: stopEvent, tabIndex: -1 }));
    }
}
